module.exports = __webpack_public_path__ + "static/media/MM Logo.959ea096.png";